// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"3e1fa6eb","425":"ca8dda57","543":"ba9b7730","660":"93f68230","787":"4acda6f2"}[chunkId] + ".chunk.js";
};